import { CheckCircle, RadioButtonUnchecked, RemoveCircle } from "@mui/icons-material";

export default function Checkbox(theme) {
  return {
    MuiCheckbox: {
      defaultProps: {
        checkedIcon: <CheckCircle />,
        indeterminateIcon: <RemoveCircle />,
        icon: <RadioButtonUnchecked />,
      },
    },
  };
}
